import { Injectable } from '@angular/core';

const NavigationData: { [id: string]: any } = {};

@Injectable({
    providedIn: 'root',
})
export class NavigationDataService {
    pushNavigationData(id: string, data: any) {
        NavigationData[id] = data;
    }

    popNavigationData(id: string) {
        const data = NavigationData[id];
        delete NavigationData[id];

        return data;
    }
}
